module.exports = __webpack_public_path__ + "img/keyboard-brightness-low.89fb96e9.svg";